module.exports = __webpack_public_path__ + "img/ic_32_profile_spielerplus.b65cd64b.svg";